import React, { Component } from "react";
import axios from "axios";
import { Translate } from "react-localize-redux";
import { Row, Col, Container } from "react-bootstrap";
import { CodeValidation, Loader } from "../index";
// import { v4 as uuidv4 } from "uuid";
// import logger from "../../utils/logger";
import PricingPlans from "./PricingPlanCard";
import DescPlan from "./descPlan";
import InvoiceTypeModal from "../Modals/invoiceTypeModal";
import { takePremiumEventLink } from "../../utils/premium-event-link";
import { ticketsUrl } from "../../utils/tickets-site";
import { fetchEventVoucherAvailable } from "../../utils/event-voucher-status";

import "../../styles/components/_premium-event.scss";

const storeId = process.env.REACT_APP_STOREID;
const base_services_api = process.env.REACT_APP_SERVICES_API_BASE;

// Тасалбарын ваучер олгогдох ЦОРЫН ГАНЦ багц
const DUO_PLAN_CODE = "sonsy_premiumduo_1m";

/* `PricingPlanCard`-ийн `DummyPlans` (зураг/тайлбар/features) массивтай ижил
   дараалал — `PricingPlans`-д `idx`-ийг ЭНЭ дарааллаар дамжуулна, mntPlans
   массив дахь БАЙРЛАЛААР биш. Duo-г ганцаараа шүүсэн үед (эвентийн урсгал)
   idx=0 болж Premium-ийн dummy өгөгдөл рүү буруу заах эрсдэлээс сэргийлнэ. */
const PLAN_CODE_ORDER = ["sonsy_premium_1m", "sonsy_premiumduo_1m", "sonsy_premiumfamily_1m"];

class Plans extends Component {
  constructor(props) {
    super(props);
    this.state = {
      merchantId: 14,
      plans: [],
      planId: "",
      errorMessage: "",
      isLoading: false,
      sessionId: "",
      selectedCurrency: "mnt",
      selectedPaymentMethod: "Card",
      subscription: "",
      subscriptionSourceType: "",
      showInvoiceModal: false,
      selectedPlan: null,
      /* Тэмдэг харуулах эсэх — серверээс ирнэ. Эхлэхдээ ЗААВАЛ false:
         хариу ирэхээс өмнө харуулбал дараа нь алга болж "анивчина". */
      eventVoucherAvailable: false,
      // Ваучер оруулах хэсэг анхандаа хураагдсан — "Ваучер код байна уу?" дарахад нээгдэнэ
      showVoucher: true,
    };
    this._isMounted = false;

    /* Тасалбарын Sonsy тэмдгээр ирсэн эсэх — ХАЯГ нь цорын ганц үнэн
       эх сурвалж. Query байхгүй бол `takePremiumEventLink` хадгалсныг
       нь ЦЭВЭРЛЭНЭ: цэсээс энгийн /premium рүү орсон хүн хагас цагийн
       өмнөх кампанит ажилд баригдах учиргүй. */
    this.state.eventLink = takePremiumEventLink(
      (props.location && props.location.search) || "",
    );

    /* ЗӨВХӨН энэ файлын доторх async setState-д. `_isMounted` -г ашиглаж
       БОЛОХГҮЙ: тэр хувьсагч хэзээ ч `true` болдоггүй (constructor ба
       componentWillUnmount хоёулаа `false` тавьдаг). */
    this._unmounted = false;

    // "Багц авах" товч руу эвентийн урсгалд НЭГ л удаа auto-scroll хийхэд ашиглана.
    this.planButtonRef = React.createRef();
    this._scrolledToPlanButton = false;
  }

  /* /premium?eventId=..  ->  /premium (цэсний холбоос) шилжилтэд энэ
     компонент ДАХИН УГСРАГДАХГҮЙ: query нь маршрутын таарцад нөлөөлдөггүй
     тул React ижил instance-ыг үлдээнэ. Иймд query өөрчлөгдөх бүрд
     хаягийг ДАХИН уншина — эс бөгөөс кампанит ажлын тэмдэг цэсээр
     ороход ч наалдаад үлдэнэ. */
  componentDidUpdate(prevProps, prevState) {
    const prev = (prevProps.location && prevProps.location.search) || "";
    const next = (this.props.location && this.props.location.search) || "";
    if (prev !== next) {
      this.setState({ eventLink: takePremiumEventLink(next) });
    }

    /* isLoading: false -> true шилжилт бол багцууд дөнгөж render хийгдсэн
       мөч (`loadPackages`). Эвентийн урсгалд Duo товч ЭНД л ГАРЧ ИРСЭН
       тул scroll/focus зөвхөн ЭНЭ мөчид, НЭГ л удаа хийнэ. */
    if (
      this.state.eventLink &&
      this.state.isLoading &&
      !prevState.isLoading &&
      !this._scrolledToPlanButton
    ) {
      this._scrolledToPlanButton = true;
      this.focusPlanButton();
    }
  }

  focusPlanButton = () => {
    if (typeof window === "undefined") return;
    // DOM commit-ийн дараагийн frame хүлээж, элемент бодитоор байрандаа орсны дараа scroll хийнэ.
    window.requestAnimationFrame(() => {
      const button = this.planButtonRef.current;
      if (button) {
        button.scrollIntoView({ behavior: "smooth", block: "center" });
        button.focus({ preventScroll: true });
      }
    });
  };

  componentDidMount() {
    this.auth = this.props.auth;

    // Load packages and profile in parallel for faster loading
    const promises = [this.loadPackages()];

    if (this.auth.isAuthenticated()) {
      promises.push(this.loadProfile());
    }

    Promise.all(promises).catch(err => {
      console.error("Error loading initial data:", err);
    });

    let selected = window.sessionStorage.getItem("selectedCurrency");
    this.setState({ selectedCurrency: selected });

    /* Кампанит ажил идэвхтэй эсэхийг сервер шийднэ — ваучер олгох
       шалгалттай ИЖИЛ дүрэм (`utils/event-voucher-status.js`). */
    fetchEventVoucherAvailable(this.state.eventLink).then((available) => {
      if (!this._unmounted) this.setState({ eventVoucherAvailable: available });
    });
  }

  componentWillUnmount() {
    this._unmounted = true;
    this._isMounted = false;
    const snowflakes = document.querySelectorAll(".snowflake");
    snowflakes.forEach((flake) => flake.remove());
  }
  // createSnowflakes = () => {
  //   const snowflakeCount = 40;
  //   const body = document.body;

  //   for (let i = 0; i < snowflakeCount; i++) {
  //     const snowflake = document.createElement("div");
  //     snowflake.className = "snowflake";
  //     snowflake.innerHTML = "❄";
  //     snowflake.style.left = Math.random() * 90 + "%";
  //     snowflake.style.animationDuration = Math.random() * 10 + 2 + "s";
  //     snowflake.style.opacity = Math.random();
  //     snowflake.style.fontSize = Math.random() * 20 + 10 + "px";
  //     snowflake.style.animationDelay = Math.random() * 10 + "s";
  //     body.appendChild(snowflake);
  //   }
  // };

  changeCurrency(e) {
    this.setState({ selectedCurrency: e.target.value });
    window.sessionStorage.setItem("selectedCurrency", e.target.value);
  }

  loadProfile = async () => {
    try {
      const resp = await axios.get(
        `${base_services_api}/users/${this.props.auth.authData.sub}/profile`,
        {
          headers: {
            StoreId: storeId,
            Authorization: `Bearer ${this.props.auth.authData.access_token}`,
          },
        }
      );

      this.setState({
        subscription: resp.data.Subscriptions[0],
        subscriptionSourceType: resp.data.Subscriptions[0]
          ? resp.data.Subscriptions[0].Source.SourceType
          : undefined,
      });
    } catch (err) {
      console.error("Error loading profile", err);
    }
  };

  // Retrieve TG plans for a specific merchant
  loadPackages = async () => {
    this.setState({ isLoading: false });

    try {
      // Make API call to load plans
      const plansResp = await axios.get(`${base_services_api}/packages/allplans`, {
        headers: { StoreId: storeId },
        params: { merchantId: `${this.state.merchantId}` },
      });

      const plans = plansResp.data;
      const allowedCodes = [
        "sonsy_premium_1m",
        "sonsy_premiumduo_1m",
        "sonsy_premiumfamily_1m",
      ];
      const filteredPlans = plans.filter((plan) => allowedCodes.includes(plan.MerchantCode));

      this.setState({
        plans: filteredPlans,
        isLoading: true,
      });
    } catch (err) {
      console.error("Error loading plans or merchants", err);
      this.setState({
        isLoading: false,
        errorMessage: "Failed to load plans. Please try again later.",
      });
    }
  };
  redirectProfile() {
    window.location.href = "/profile";
  }

  createInvoice(plan) {
    console.log("Creating invoice for plan:", plan);
    console.log("Current modal state:", this.state.showInvoiceModal);

    if (!this.auth.isAuthenticated()) {
      /* Нэвтэрч ирээд ЯГ ЭНЭ хаяг руугаа (query-тэйгээ) буцах ёстой.
         Эвентийн урсгалд query алга болбол `takePremiumEventLink` нь
         хадгалсан хам сурвалжийг ЦЭВЭРЛЭЧИХНЭ — тэмдэг ч алга болж,
         ваучер ч олгогдохгүй. `containers/login.js` үүнийг нэг удаа
         уншаад арчина. */
      sessionStorage.setItem(
        "loginReturnUrl",
        `${this.props.location.pathname}${this.props.location.search}`,
      );
      this.props.history.push("/login");
      return;
    } else {
      // Show the invoice modal
      this.setState(
        {
          showInvoiceModal: true,
          selectedPlan: plan,
        },
        () => {
          console.log("Modal state after setState:", this.state.showInvoiceModal);
        },
      );
    }
  }

  /**
   * Тэмдэг дарахад очих тасалбарын хаяг.
   *
   * Хаягаараа эвентээс ирсэн бол ТУХАЙН эвент рүү, эс бөгөөс тасалбарын
   * сайтын нүүр рүү. Тэмдэг нь Duo дээр ҮРГЭЛЖ гарна — "Duo авбал
   * эвентийн ваучер дагалдана" гэдэг нь бүх Duo худалдан авалтад
   * хамаарна (`EVENT_COUPON_DEFAULT_*`, server/.env).
   */
  ticketsHref = () => {
    const link = this.state.eventLink;
    return link ? ticketsUrl(`/${link.eventId}`) : ticketsUrl("/");
  };

  handleInvoiceModalClose = () => {
    this.setState({
      showInvoiceModal: false,
      selectedPlan: null,
    });
  };

  handleInvoiceSubmit = (invoiceData) => {
    console.log("Invoice data submitted:", invoiceData);
    console.log("Selected plan:", this.state.selectedPlan);

    const { selectedPlan } = this.state;

    // Close the modal
    this.handleInvoiceModalClose();

    // Navigate to PaymentPage with invoice data and selected plan
    this.props.history.push({
      pathname: "/payment",
      state: {
        invoiceData: invoiceData,
        selectedPlan: selectedPlan,
        /* Аль тасалбарын ваучерыг олгохыг төлбөрийн хуудас мэдэх ёстой.
           Route state алдагдвал sessionStorage-оос сэргээнэ
           (`utils/premium-event-link.js`). */
        eventLink: this.state.eventLink || undefined,
      },
    });
  };

  // tconnect
  // createSession(plan, invoiceData = null) {
  //   if (!this.auth.isAuthenticated()) {
  //     this.props.history.push("/login");
  //     return;
  //   } else {
  // this.setState({ planId: plan.MerchantCode }, function () {
  //   const invoiceId = `${uuidv4()}_${this.state.planId}`;

  //   if (window.location.hostname !== "localhost") {
  //     axios.post(`/api/cache/item`, {
  //       key: invoiceId,
  //       value: this.auth.authData.sub,
  //     });
  //   }

  //       try {
  //         // const amount = plan.Cost;

  //         //amount for test
  //         const amount = 100;

  // const isMobile = navigator.userAgentData
  //   ? navigator.userAgentData.mobile
  //   : /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  //       navigator.userAgent,
  //     );

  // const os = isMobile ? "mobile" : "pc";

  // let checkoutModel = {
  //   client_id: process.env.REACT_APP_THIRD_PARTY_API_CLIENT_ID,
  //   client_secret: process.env.REACT_APP_THIRD_PARTY_API_CLIENT_SECRET,
  //   deviceType: os,
  //   amount: amount,
  //   description: "Music package",
  //   languageCode: "mn",
  //   payment_type: "purchase",
  //   invoice_id: invoiceId,
  //   currency: "MNT",
  //   device: os,
  //   redirect_url: "https://staging.sonsy.mn/success",
  // };
  //         const authData = this.auth.authData || this.props.auth?.authData;
  //         if (authData) {
  //           if (authData.phone?.number) {
  //             checkoutModel.phone = authData.phone.number;
  //           } else if (authData.username) {
  //             checkoutModel.email = authData.username;
  //           }
  //         }

  // const subscriberName = checkoutModel.phone || checkoutModel.email || "unknown";

  //         axios
  //           .post(`${process.env.REACT_APP_THIRD_PARTY_API_GET_TOKEN}`, checkoutModel)
  //           .then(async (resp) => {
  //             const resourceUrl = `${process.env.REACT_APP_THIRD_PARTY_API_GET_RESOURCE}?token=${resp.data?.result?.token}&os=PC`;
  //             console.log("Mobi payment gateway response", resp);
  // await logger.log(
  //   "info",
  //   "Creating session for plan",
  //   {
  //     checkoutModel,
  //   },
  //   JSON.stringify(resp.data),
  //   {
  //     currentProcess: "created",
  //     subscriberName: subscriberName,
  //     packageName: this.state.planId,
  //     purchasePrice: amount,
  //     orderNumber: invoiceId,
  //     tgUserId: this.auth.authData.sub,
  //   },
  // );
  //             window.location.href = resourceUrl;
  //           })
  //           .catch((err) => {
  // logger.log(
  //   "error",
  //   "Error from THIRD PARTY PAYMENT",
  //   {
  //     checkoutModel,
  //   },
  //   JSON.stringify(err),
  //   {
  //     currentProcess: "created",
  //     subscriberName: subscriberName,
  //     packageName: this.state.planId,
  //     purchasePrice: amount,
  //     orderNumber: invoiceId,
  //     tgUserId: this.auth.authData.sub,
  //   },
  // );
  //   this.setState({ message: err.message });
  // });
  //       } catch (error) {
  // logger.log(
  //   "error",
  //   "Error in createSession",
  //   {
  //     error,
  //     plan,
  //     invoiceId,
  //   },
  //   "microsite select plan",
  //   {
  //     currentProcess: "created",
  //     subscriberName: this.auth.authData.sub,
  //     packageName: this.state.planId,
  //     purchasePrice: plan.Cost,
  //     orderNumber: invoiceId,
  //     tgUserId: this.auth.authData.sub,
  //   },
  // );
  //         this.state({ message: error.message });
  //       }
  //     });
  //   }
  // }

  render() {
    const { isLoading } = this.state;
    // const auth = this.props.auth;
    // let plans;
    // let currencySelector;
    let finePrint;
    // let packageDetails = (title, value) => {
    //   return (
    //     <div className="package-details wow fadeInUp">
    //       <div className="detail-title">
    //         <img src="/img/correct-icon.png" alt="correct-icon" />
    //         <Translate id={title} />
    //       </div>
    //       <div className="detail-value">
    //         {typeof value === "number" ? <p>{value}</p> : <Translate id={value} />}
    //       </div>
    //     </div>
    //   );
    // };

    let mntPlans = this.state.plans.filter((plan) => {
      return plan.Currency === "MNT";
    });

    /* Тасалбарын Sonsy тэмдгээр ирсэн бол (/premium?eventId=..&ticketId=..)
       зөвхөн Duo багцыг харуулна — ваучер ЗӨВХӨН Duo дээр олгогддог тул
       бусад багц энд сонголт биш. */
    if (this.state.eventLink) {
      mntPlans = mntPlans.filter((plan) => plan.MerchantCode === DUO_PLAN_CODE);
    }

    finePrint = (
      <Col sm="12">
        <p>
          <small>
            {(this.state.subscriptionSourceType === "Apple IAP" && (
              <Translate id="subscription.apple" />
            )) ||
              (this.state.subscriptionSourceType === "Google Play" && (
                <Translate id="subscription.google" />
              ))}
          </small>
        </p>
      </Col>
    );
    // }

    if (!isLoading) {
      return (
        <Col sm="12" className="text-center">
          <div className="container">
            <Loader />
          </div>
          <p>
            <Translate id="content.loading-plans" />
          </p>
        </Col>
      );
    } else {
      return (
        <Col sm="12">
          {/* {currencySelector} */}
          {/* eventLink үед Duo ганцаараа үлддэг тул төв рүү байрлуулна */}
          <Row className={`text-center${this.state.eventLink ? " justify-content-center" : ""}`}>
            {mntPlans.map((plan) => {
              const idx = PLAN_CODE_ORDER.indexOf(plan.MerchantCode);
              return (
                <Col key={plan.MerchantCode} sm="12" md="6" lg="4">
                  <PricingPlans
                    plan={plan}
                    idx={idx}
                    onClick={() => this.createInvoice(plan)}
                    eventBadge={
                      this.state.eventVoucherAvailable && plan.MerchantCode === DUO_PLAN_CODE
                        ? this.ticketsHref()
                        : null
                    }
                    buttonRef={
                      this.state.eventLink && plan.MerchantCode === DUO_PLAN_CODE
                        ? this.planButtonRef
                        : undefined
                    }
                  />
                  {/* <PricingPlans plan={plan} idx={idx} onClick={() => this.createSession(plan)} /> */}
                </Col>
              );
            })}
          </Row>
          {/* Дараалал: багцууд → ваучер → юу багтдаг (харьцуулах хүснэгт) */}
          <Container className="voucher-reveal">
            {this.state.showVoucher ? (
              <CodeValidation onValidate={this.redirectProfile} auth={this.auth} />
            ) : (
              <button
                type="button"
                className="voucher-toggle"
                aria-expanded="false"
                onClick={() => this.setState({ showVoucher: true })}
              >
                <Translate id="content.voucher-toggle" />
              </button>
            )}
          </Container>
          <Container>
            <DescPlan />
          </Container>
          <Row className="text-center">{finePrint}</Row>
          {this.state.errorMessage !== "" && (
            <Col sm="12" className="text-center">
              {this.state.errorMessage}
            </Col>
          )}
          <InvoiceTypeModal
            isOpen={this.state.showInvoiceModal}
            onClose={this.handleInvoiceModalClose}
            onSubmit={this.handleInvoiceSubmit}
          />
        </Col>
      );
    }
  }
}

export default Plans;
